import axios from 'axios'
import { ElMessage } from 'element-plus'
// 创建axios实例
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    // baseURL: '/api',
    baseURL: 'http://43.137.46.89:8686',
    // baseURL: 'http://localhost:8686',
    // 超时
    timeout: 10000
})

// 请求拦截
// service.interceptors.request.use((config)=>{
//     const token =localStorage.getItem("access_token");
//     if (token){
//         config.headers.Authorization =token
//     }
//     return config;
// },(error)=>{
//     return Promise.reject(error);
// })


// service.interceptors.response.use((response)=>{
//     return response
// },(error)=>{
//     return Promise.reject(error)
// })

export default service
